import React from "react";

type ProfileFieldProps = {
  title: string;
  value: string;
} & React.ComponentPropsWithoutRef<"p">;

export function ProfileField({ title, value, ...props }: ProfileFieldProps) {
  return (
    <div className="tw:mb-4">
      <p className="tw:mb-1 tw:text-sm tw:font-bold">{title}</p>
      <p className="tw:text-sm tw:break-all" {...props}>
        {value}
      </p>
    </div>
  );
}
